import React from "react";

import Searchbar from "../../utils/searchbar/Searchbar";
import SearchPage from "../../search/SearchPage";

class PageSearch extends React.PureComponent {
	render() {
		return (
			<React.Fragment>
				<Searchbar
					placeholder={"Search page titles"}
					component={SearchPage}
					searchEndpoint={"search/content"}
					{...this.props}
					userType="admin"
					index="permalink"
					params={{
						language: process.env.REACT_APP_LANGUAGE
					}}
				/>
			</React.Fragment>
		);
	}
}

export default PageSearch;



// WEBPACK FOOTER //
// ./src/components/admin/pages/PageSearch.js